<template>
  <page :back-to="getPreviousUrl" :title="pageTitle" size="is-widescreen">
    <div v-if="notification.data">
      <div class="card mb-6">
        <div class="card-header">
          <div class="card-header-title">Notification</div>
        </div>

        <div class="card-content is-paddingless">
          <table class="table is-fullwidth">
            <tbody>
              <tr>
                <td style="width: 250px;">Episode</td>
                <td>{{ notification.data.id }}</td>
              </tr>

              <tr>
                <td style="width: 250px;">Ажилтан</td>
                <td>
                  <router-link :to="'/users/' + notification.data.composer_user.id">
                    <user-tile :user="notification.data.composer_user"></user-tile>
                  </router-link>
                </td>
              </tr>

              <tr>
                <td style="width: 250px;">Хүлээн авагч</td>
                <td>{{ notification.data.to }}</td>
              </tr>

              <tr>
                <td>Title</td>
                <td>{{ notification.data.title }}</td>
              </tr>

              <tr>
                <td>Дэд гарчиг</td>
                <td>{{ notification.data.subtitle }}</td>
              </tr>

              <tr>
                <td>Агуулга</td>
                <td>{{ notification.data.body }}</td>
              </tr>

              <tr>
                <td>Image</td>
                <td>
                  <figure
                    v-if="notification.data.image_url"
                    class="image is-64x64"
                    style="overflow: hidden; display: flex; align-items:center; justify-content:center"
                  >
                    <img :src="notification.data.image_url" />
                  </figure>
                </td>
              </tr>

              <tr>
                <td>Link</td>
                <td>{{ notification.data.link }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <div class="card-header-title">Fcm хариу</div>
        </div>

        <div class="card-content is-paddingless">
          <pre>{{ notification.data.response }}</pre>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import UserTile from "./../../../../../components/UserTile";

export default {
  components: {
    UserTile
  },

  data() {
    return {
      notification: new window.RemoteData(
        "/api/pns/notifications/" + this.$route.params.id
      ).load()
    };
  },

  computed: {
    pageTitle() {
      return this.notification.data
        ? "Notification - #" + this.notification.data.id
        : "";
    },

    getPreviousUrl() {
      return localStorage.getItem('previous');
    },
  }
};
</script>
